"use client"
import { Megaphone } from "lucide-react"
import { type UnifiedMessage } from "@/lib/api"
import { formatCoMessageTime } from '@/app/utils/useFormat';
import { getLocalizedName } from "@/app/utils/useLocale";
import { useTranslation } from "react-i18next";
// 消息类型：15公告
export function AnnouncementItem({
    announcement,
    children,
    isDropdown = false,
}: {
    announcement: UnifiedMessage,
    children?: React.ReactNode,
    isDropdown?: boolean,
}) {
    const { i18n } = useTranslation();
    const lang = i18n.language;
    const title = getLocalizedName({
        name: announcement.variables.title,
        nameEn: announcement.variables.titleEn,
        nameJa: announcement.variables.titleJa,
        nameKo: announcement.variables.titleKo,
        nameYue: announcement.variables.titleYue,
    }, lang);
    const summary = getLocalizedName({
        name: announcement.variables.summary,
        nameEn: announcement.variables.summaryEn,
        nameJa: announcement.variables.summaryJa,
        nameKo: announcement.variables.summaryKo,
        nameYue: announcement.variables.summaryYue,
    }, lang);
    const showTimeWithChildren = Boolean(isDropdown && children);
    return (
        <>
            <div className="bg-background-3/10 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 text-font-primary border border-button-border/50">
                <Megaphone className="w-4 h-4" />
            </div>
            <div className="flex-1 min-w-0">
                {showTimeWithChildren ? (
                    <div className="flex items-center justify-between gap-2 mb-1">
                        <div className="min-w-0 flex items-center gap-2 flex-wrap">{children}</div>
                        <span className="text-xs text-font-primary/50 flex-shrink-0 whitespace-nowrap">
                            {formatCoMessageTime(announcement.createTime)}
                        </span>
                    </div>
                ) : null}
                <div className="flex items-start justify-between gap-2 mb-1">
                    <h4 className="text-sm font-medium text-font-primary line-clamp-1">
                        {!isDropdown && children}
                        {title}
                    </h4>
                    {!showTimeWithChildren && (
                        <span className="text-xs text-font-primary/50 flex-shrink-0 whitespace-nowrap">
                            {formatCoMessageTime(announcement.createTime)}
                        </span>
                    )}
                </div>
                <p
                    className="text-xs text-font-primary/70 line-clamp-2"
                    dangerouslySetInnerHTML={{ __html: summary || '' }}
                />
            </div>
        </>
    )
}